/**
 * Converts a stored photo path into a full public Supabase Storage URL.
 *
 * Handles both cases defensively:
 *  - If the value already starts with "http", it is returned as-is
 *    (older rows that already stored a full URL).
 *  - Otherwise the value is treated as a bare storage path and the
 *    public /object/public/ URL is constructed from it.
 *
 * @param {string} pathOrUrl - Raw value from photo_urls column
 * @returns {string} Fully-qualified public URL
 */
export function buildPhotoUrl(pathOrUrl) {
  if (!pathOrUrl) return '';
  if (pathOrUrl?.startsWith('http')) return pathOrUrl;

  const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL ?? '';
  return `${supabaseUrl}/storage/v1/object/public/service-request-photos/${pathOrUrl}`;
}
